import { useEnvConfigStore } from "@/store/env.store";
import axios from "axios";
import { useGlobalStore } from "@/store/globalStore";


export class SpanSupportAuthApiServices {
  async postMethod(url: string, data: any) {
   const {UserDetails} = useGlobalStore()
    url = useEnvConfigStore().envInfo?.Span_Support_API_Url + url;
    try {
      const response = await axios({
        method: "post",
        headers:{
        ProdKey:UserDetails.value?.ProductKey,
        'CallFrom': "AIChatBot"
        },
        url,
        data,
      });
      return response.data;
    } catch (err: any) {
      if (
        err.response !== undefined &&
        err.response.status !== undefined &&
        err.response.status === 401
      ) {
        console.log(err);
      }
    }
  }
}
